<template>
    <common-content-spacer height="large" class="ancillary-table">
        <common-page-header
            v-if="showHeader"
            size="medium"
            :heading="$t('pages.ancillary.ancillary_table.heading')"
        ></common-page-header>
        <p v-if="checkedValues.length">
            {{ $t('pages.ancillary.ancillary_table.selected_tests') }}: {{ checkedValues.map((item) => item.name).join(', ') }}
        </p>
        <div class="ancillary-table__container">
            <div
                v-for="(value, i) in ancillaryServices"
                :key="i"
                class="ancillary-table__container--wrapper ancillary-table__container--wrapper-selection"
            >
                <div>
                    <div class="ancillary-table__container--group ancillary-table__container--group-selection">
                        <common-icon size="gigantic" :name="getAncillaryIcon(value.id)"></common-icon>
                        <p class="ancillary-table__container--group--text">{{ value.name }}</p>
                    </div>
                    <div class="practice-information-form__overflow-y practice-information-form__overflow-y-selection">
                        <div>
                            <ul class="badges__list badges__list--link">
                                <li
                                    v-for="(element, index) in value.facilityServiceTypes"
                                    :key="index"
                                    ref="badge"
                                    :class="getLoaderClass"
                                >
                                    <span @click="expandService(element)">{{ element.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="selectedService.id">
                <div v-if="!isSending">
                    <p class="ancillary-table__container--group-title">
                        {{ $t('pages.ancillary.ancillary_table.selected_service') }}: {{ selectedService.name }}
                    </p>
                    <ancillary-service-tests-view
                        :ancillaryServiceData="ancillaryServiceData"
                        :prefillValues="checkedValuesIds"
                        :showButtons="false"
                        @ancillary-tests-selection-changed-value="selectionChanged"
                    ></ancillary-service-tests-view>
                </div>
                <div v-else>
                    <common-loader :isProcessing="isSending"></common-loader>
                </div>
            </div>
        </div>
        <common-buttons>
            <common-button
                :disabled="!checkedValues.length"
                :isProcessing="isSending"
                :label="$t('common.microcopy.done')"
                type="primary"
                @click="emitEvent({ name: 'proceed-to-patient-form', payload: checkedValuesIds })"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import AncillaryServiceTestsView from 'components/page-elements/ancillary-service-tests/AncillaryServiceTestsView'
    import FacilityServicesAPI from 'api/FacilityServicesAPI'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'

    export default {
        mixins: [HandleRequestMixin],

        components: {
            AncillaryServiceTestsView,
        },

        props: {
            ancillaryServices: { type: Array, required: true },
            showHeader: { type: Boolean, default: true },
        },

        data() {
            return {
                checkedValues: [],
                isSending: false,
                selectedService: {},
                ancillaryServiceData: {},
                selectedTests: [],
                checkedValuesIds: [],
            }
        },

        computed: {
            getLoaderClass() {
                return {
                    'badges__badge badges__badge--link': true,
                    'badges__badge badges__badge--link--processing': this.isSending,
                }
            },
        },

        methods: {
            getAncillaryIcon(key) {
                switch (key) {
                    case 1:
                        return 'ancillary-diagnostic'
                    case 2:
                        return 'ancillary-therapeutic'
                    case 3:
                        return 'ancillary-custodial'
                }
            },

            selectionChanged(items) {
                for (let item of items) {
                    if (this.checkedValuesIds.includes(item.id)) {
                        this.checkedValuesIds.splice(this.checkedValuesIds.indexOf(item.id), 1)
                        this.checkedValues.splice(this.checkedValues.indexOf(item), 1)
                    } else {
                        this.checkedValuesIds.push(item.id)
                        this.checkedValues.push(item)
                    }
                }
            },

            expandService(service) {
                this.selectedService = service
            },
        },

        watch: {
            selectedService(newVal) {
                this.isSending = true
                FacilityServicesAPI.getFacilityServiceSubGroups(newVal.id)
                    .then((response) => {
                        this.ancillaryServiceData = response
                    })
                    .finally(() => {
                        this.isSending = false
                    })
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/page-elements/ancillary-table/_ancillary-table';
</style>
